import {nextFrame} from "@/frontend-v3/Utils.js";

const images = 4;
let currentImage = null;

setInterval(swapImage, 15 * 1000); // every 15 seconds

async function swapImage() {
    // Don't swap if the document is hidden
    if (document.visibilityState === 'hidden') return;

    /** @type {HTMLImageElement} */
    const target = document.getElementById('loginScreenImage');
    if (! target) return;

    if (currentImage === null) {
        // get the current index from the image src
        const src = target.src;
        const file = src.split('/').pop();
        currentImage = parseInt(file.split('.').shift(), 10);
    }

    currentImage = (currentImage % images) + 1;

    const path = target.src.split('/').slice(0, -1).join('/') + `/${currentImage}.jpg`;
    // create a new image and animate it in
    /** @type {HTMLImageElement} */
    const image = target.cloneNode();
    image.src = path;
    image.classList.add('translate-x-4', 'opacity-0');
    target.parentNode.append(image);
    target.classList.add('-translate-x-4', 'opacity-0');

    await nextFrame();

    image.classList.remove('translate-x-4', 'opacity-0');

    setTimeout(() => {
        // Remove all old images
        const targets = document.querySelectorAll('#loginScreenImage');
        targets.forEach((el, index) => {
            if (index < targets.length - 1) {
                el.remove();
            }
        });
    }, 1000);

}


